const taskTemplates = require('../../task-templates');

const tasksData = [
	/* Case 1 */
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 1,
		taskId: 'social-sort-intros',
		title: 'Opgave 1',
		text: `Når man starter på gymnasiet, får man altid en spændende introduktion. Placer de forskellige elementer, som alle hører til en god intro, i de kategorier de passer til.`,
		hintText: `Nogle ting hører til fagligt, andre til socialt.`,
		popupText: `Når man starter på gymnasiet, får man en intro, der både handler om at lære skolen at kende og at blive en del af fællesskabet.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'social', title: `Det sociale`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'school', title: `Det skolerelaterede`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'notIntro', title: `Ikke en del af intro`}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 1, text: `Møde de nuværende elever`, categoryIds: ['social']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 2, text: `Teambuilding`, categoryIds: ['social']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 3, text: `Gruppearbejde i klassen`, categoryIds: ['school']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 4, text: `Info om fag`, categoryIds: ['school']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 5, text: `Udlevering af bøger`, categoryIds: ['school']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 6, text: `Introduktion til eksamener`, categoryIds: ['notIntro']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 7, text: `Gennemgang af skolens sikkerhedsregler`, categoryIds: ['notIntro'], layout: 'item-halfdouble'}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 8, text: `Oplæring i skolens IT`, categoryIds: ['notIntro']}),
		]
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 2,
		taskId: 'social-order-traditions',
		title: 'Opgave 2',
		text: `Gymnasiet er fuld af fede traditioner og fester, som hele skoleåret er bygget op omkring. Men hvad sker hvornår?
			<br /><br />Sæt disse fester og traditioner i den rækkefølge, de normalt sker – fra starten af gymnasiet til slutningen.`,
		hintText: `Tænk på, at introfesten ligger i starten.`,
		popupText: `Traditioner og fester er en stor del af gymnasielivet, og de kommer i en bestemt rækkefølge – fra man lige er startet, til man bliver student.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1, text: `Introfest`, correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, text: `Studieture`, correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, text: `Gallafest`, correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, text: `Dimissionsfest`, correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, text: `Studenterkørsel`, correctOrderNumbers: [5]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 6, text: `Reunion fest`, correctOrderNumbers: [6]
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 3,
		subtype: 'images',
		title: 'Opgave 3',
		taskId: 'social-mc-extra-fun',
		text: `På gymnasiet sker der masser af sjove ting uden for timerne! Hvilke af disse ting tror I, eleverne typisk laver sammen efter skole i deres fritid?`,
		hintText: `Tænk over, hvad I tror, gymnasiet normalt arrangerer for eleverne.`,
		// popupText: `Gymnasiet står for de aktiviteter, hvor hele skolen eller mange elever deltager sammen. De andre ting laver man typisk i sin fritid.`,
		layout: 'stx-activities',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'chess', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'parties', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'gaming', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'homework', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'cinema',
			}),
			// Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
			// 	id: 'poker'
			// }),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'diving',
			}),
		],
	}),

	/* Case 2 */
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 1,
		title: 'Opgave 1A',
		taskId: 'social-input-study-trip-how-many',
		text: `Alle glæder sig til studietur – men hvor mange plejer man egentlig at få på STX?`,
		hintText: `Det kan nemt googles.`,
		popupText: `Studieture er noget, alle gymnasier har – men hvor mange, det varierer fra skole til skole.`,
		answer: 1,
		unit: null
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 2,
		title: 'Opgave 1B',
		taskId: 'social-input-study-trip-when',
		lockedById: 'social-input-study-trip-how-many',
		text: `Hvornår på STX plejer studieturen at være? Skriv: Første, Andet eller Tredje.`,
		hintText: `Det kan googles under “STX studietur”.`,
		popupText: `Første år er fyldt med intro og opstart og tredje år er fyldt med eksamensforberedelse og afslutning. `,
		answer: 'Andet',
		subtype: 'string',
		unit: 'år',
		image: 'stx-study-trip'
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 3,
		title: 'Opgave 1C',
		taskId: 'social-input-study-trip-how-many-depends',
		lockedById: 'social-input-study-trip-when',
		text: `Kan antallet af studieture være forskelligt alt efter studieretning, tror I?`,
		hintText: `I kan finde svaret her: 
			<br /><br />https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/almen-studentereksamen-stx`,
		popupText: `Det kan være forskelligt, det afhænger af både gymnasiet og dine valgte studieretninger og fag.`,
		answer: 'Ja',
		subtype: 'string',
		unit: null
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 4,
		title: 'Opgave 2',
		taskId: 'social-mc-study-trip-experiences',
		text: `Hvad tror I, man oplever og laver på en studietur?`,
		hintText: `Tænk på klassiske ture med klassen.`,
		popupText: `På en studietur laver man både faglige ting og sjove oplevelser sammen – det er en blanding af skole og socialt fællesskab.`,
		image: 'stx-study-trip-2',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Tager på udflugter', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Tager ud og spiser', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Tager på Sightseeing', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Laver lektier'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: 'Fester om aftenen'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 6, text: 'Tager i biografen'
			})
		],
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 5,
		taskId: 'social-order-stx-most-important',
		title: 'Opgave 3',
		text: `Hvad tror I er vigtigst, når man går på gymnasiet? Sæt i rækkefølge med det vigtigste øverst.`,
		hintText: `Tænk i hvad din fornuft siger, og ikke kun hvad du synes er sjovest.`,
		popupText: `Der er mange meninger om, hvad der er vigtigst på gymnasiet – men at møde op og lave sine lektier er stadig det, der hjælper flest med at komme igennem.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1, text: `Møde op hver dag`, correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, text: `Lektier og forberedelse`, correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, text: `Deltage i gruppearbejde`, correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, text: `Have det sjovt og slappe af`, correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, text: `Få nye venner`, correctOrderNumbers: [5]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 6, text: `At komme tidligt hjem`, correctOrderNumbers: [6]
			})
		]
	}),

	/* Case 3 */
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 1,
		taskId: 'social-sort-myths',
		title: 'Opgave 1',
		text: `Sortér udsagnene i to kategorier: Sandt og Falsk om studielivet på gymnasiet. Kan I spotte, hvad der er sandt – og hvad der bare er rygter?`,
		hintText: `Nogle af udsagnene er bare overdrivelser.`,
		layout: 'halfdouble-height',
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'fact', title: `Sandt`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'myth', title: `Falsk`})
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 1, text: `Gymnasiet arrangerer fester for eleverne`, categoryIds: ['fact']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 2, text: `Man kommer ikke uden om gruppearbejde`, categoryIds: ['fact']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 3, text: `Elevrådet arbejder for elevernes interesser`, categoryIds: ['fact']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 4, text: `De voksne hjælper med at skabe fællesskaber mellem elever`, categoryIds: ['fact']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 5, text: `Der er fester hver weekend`, categoryIds: ['myth']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 6, text: `Der er mange som ikke gennemfører`, categoryIds: ['myth']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 7, text: `Mobiltelefoner er altid ok på gymnasiet`, categoryIds: ['myth']})
		]
	}),
	Object.assign({}, taskTemplates.paperDollTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'social-paper-doll-party',
		layout: 'social-stx-party',
		avatarId: 'avatar-4',
		text: `Weekenden nærmer sig, og der er fest på gymnasiet! Hjælp eleven med at vælge det rigtige tøj og udstyr, så hun er klar til en fed aften. Klik på OK, når I mener, I har styr på det.`,
		hintText: `Tænk på, hvad man normalt tager med til en fest.`,
		items: [
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'dress', title: 'Smart kjole', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'safety-vest', title: 'Sikkerhedsvest'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'phone-2', title: 'Mobil', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'makeup', title: 'Make up', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'pizza', title: 'Pizza'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'books', title: 'Bøger'
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 3,
		title: 'Opgave 3',
		taskId: 'social-what-makes-it-awesome',
		text: `Fællesskabet på gymnasiet gør hverdagen sjovere og mere spændende. Hvad tror I, flest elever har svaret er med til at gøre det fedt?`,
		hintText: `Fester er ikke det eneste, der tæller.`,
		popupText: `Det, der gør gymnasiet særligt, er fællesskabet – både gennem undervisning, fester og aktiviteter, hvor man møder nye venner.`,
		image: 'stx-social-friends',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Arrangementer og festerne', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Lektierne og undervisningen',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Skolens sportsaktiviteter', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'En masse nye venner', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: 'At det er svært og udfordrende'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 6, text: 'Alle de nye regler'
			})
		],
	}),
	Object.assign({}, taskTemplates.spotErrorsTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 4,
		title: 'Opgave 4',
		taskId: 'social-spot-errors-packing',
		layout: 'social-spot-errors-packing',
		text: `En elev er ved at pakke til studieturen i udlandet og glæder sig helt vildt. Kan I spotte, hvad der mangler? Klik på tingene, og tryk OK, når I tror, I har fundet dem alle.`,
		hintText: `Måske eleven er ved at glemme nogle ting? `,
		errors: [
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'passport'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'wallet'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'phone'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'computer'})
		]
	})
];

let taskIdsArr = [];
tasksData.forEach((task, index) => {
	/* Assign unique id used for navigation */
	task.id = 'stxhf-social-' + (index + 1 < 10 ? '0' : '') + (index + 1);

	/* Check taskId is set when required and unique */
	if (task.taskId) {
		if (taskIdsArr.indexOf(task.taskId) >= 0) {
			console.error('Task id not unique: ', task.taskId);
		} else {
			taskIdsArr.push(task.taskId);
		}
	} else {
		console.error('Missing task id for task: ', task);
	}
});

export {
	tasksData
};